import client from '../httpClient';

const deleteProhibitWordsApi = (wordId) => {
  return client.delete(`/prohibited-words/${wordId}`);
};

export default deleteProhibitWordsApi;
